import { render, staticRenderFns } from "./PpvInsightsTable.vue?vue&type=template&id=1df7a212&scoped=true"
import script from "./PpvInsightsTable.vue?vue&type=script&lang=js"
export * from "./PpvInsightsTable.vue?vue&type=script&lang=js"
import style0 from "./PpvInsightsTable.vue?vue&type=style&index=0&id=1df7a212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df7a212",
  null
  
)

export default component.exports